/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rsvpnotgoing2Inputs */

const en_rsvpnotgoing2 = /** @type {(inputs: Rsvpnotgoing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not going`)
};

const de_rsvpnotgoing2 = /** @type {(inputs: Rsvpnotgoing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht dabei`)
};

/**
* | output |
* | --- |
* | "Not going" |
*
* @param {Rsvpnotgoing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rsvpnotgoing2 = /** @type {((inputs?: Rsvpnotgoing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rsvpnotgoing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rsvpnotgoing2(inputs)
	return de_rsvpnotgoing2(inputs)
});
export { rsvpnotgoing2 as "rsvpNotGoing" }